import React from 'react';
import type { ChildrenProp } from '../common-types';

/**
 * Properties for a {@link DocumentGroup} component.
 */
export interface DocumentGroupProps extends Required<ChildrenProp> {
  /**
   * Optional title of the group.
   */
  title?: string;
}

/**
 * Component used to link multiple {@link Document}s together visually.
 *
 * @param properties {@link DocumentGroupProps} object
 * @return the rendered {@link JSX.Element}
 * @constructor
 */
export function DocumentGroup({
  title,
  children,
  ...props
}: Readonly<DocumentGroupProps>): JSX.Element {
  return React.Children.count(children) > 1 ? (
    // add group container if more than 1 child
    <div {...props} className={'ehs-document-group'}>
      {title ? <h3 className="document-group-title">{title}</h3> : <></>}
      {children}
    </div>
  ) : (
    // wrapped with empty element, to avoid any kind of casting. This is either 1 or 0 Document components
    <>{children}</>
  );
}
